var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * Client-wide destroy signal.
 */
import { Lifecycle, scoped } from 'tsyringe';
import { StreamrClientError } from './StreamrClientError';
import { Signal } from './utils/Signal';
/**
 * Listen to onDestroy to fire cleanup code on destroy.
 * Careful not to introduce memleaks.
 * Trigger this to destroy the client.
 */
let DestroySignal = class DestroySignal {
    onDestroy = Signal.once();
    trigger = this.destroy;
    abortSignal;
    constructor() {
        const controller = new AbortController();
        this.abortSignal = controller.signal;
        this.onDestroy.listen(() => {
            controller.abort();
        });
    }
    destroy() {
        return this.onDestroy.trigger();
    }
    assertNotDestroyed() {
        if (this.isDestroyed()) {
            throw new StreamrClientError('Client is destroyed. Create a new instance', 'CLIENT_DESTROYED');
        }
    }
    isDestroyed() {
        return this.onDestroy.triggerCount() > 0;
    }
};
DestroySignal = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [])
], DestroySignal);
export { DestroySignal };
//# sourceMappingURL=DestroySignal.js.map